import axios from 'axios';

// Imposta il baseURL con /api
const api = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || '') + '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle specific error cases
      switch (error.response.status) {
        case 401:
          // Unauthorized - clear token and redirect to login
          localStorage.removeItem('token');
          window.location.href = '/login';
          break;
        case 403:
          // Forbidden - redirect to unauthorized page
          console.error('Access forbidden:', error.response.data?.message);
          // Solo reindirizza se non stiamo già sulla pagina unauthorized
          if (window.location.pathname !== '/unauthorized') {
            window.location.href = '/unauthorized';
          }
          break;
        case 404:
          // Not Found - log but don't redirect (let component handle it)
          console.error('Resource not found:', error.response.data?.message);
          break;
        case 500:
        case 502:
        case 503:
          // Server errors - redirect to error page
          console.error('Server error:', error.response.data?.message);
          // Solo reindirizza se non stiamo già sulla pagina di errore
          if (window.location.pathname !== '/error') {
            window.location.href = '/error';
          }
          break;
        default:
          console.error('API Error:', error.response.data);
      }
    } else if (error.request) {
      // Request made but no response received
      console.error('Network error - no response received');
      if (window.location.pathname !== '/error') {
        window.location.href = '/error';
      }
    }
    return Promise.reject(error);
  }
);

export default api;